import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { HoursMinutes } from 'src/app/core/models/time.model';

@Injectable({
	providedIn: 'root'
})
export class DateHelperService {

	getMinutesFromHoursMinutes(time: string): number {
		const parts = time.split(':');
		const hours = Number(parts[0]);
		const mins = Number(parts[1]);

		return (60 * hours) + mins;
	}

	getHoursMinutesFromMinutes(minutes: number): HoursMinutes {
		const hours = (minutes / 60);
		const rhours = Math.floor(hours);
		const min = (hours - rhours) * 60;
		const rmin = Math.round(min);

		return { hours: rhours, minutes: rmin };
	}

	getNowISO(): string {
		return moment().toISOString();
	}

	getNowInMilliseconds() {
		return Date.now();
	}

	isToday(dateString: string): boolean {
		const formattedDate = moment(dateString).format('MM-DD-YYYY');
		const today = moment().format('MM-DD-YYYY');

		return formattedDate == today;
	}

	// LOC-1086
	isSameDay(dateString1: string, dateString2: string): boolean {
		const formattedDate1 = moment(dateString1).format('MM-DD-YYYY');
		const formattedDate2 = moment(dateString2).format('MM-DD-YYYY');

		return formattedDate1 == formattedDate2;
	}

	getClockTime(date: Date) {
		const hours = date.getHours();
		const min = date.getMinutes();

		return `${this.hoursToString(hours)}:${this.minutesToString(min)}${this.getMeridiem(hours)}`;
	}

	private hoursToString(hours: number): string {
		if (hours > 0 && hours <= 12) {
			return '' + hours;
		}

		return (hours > 12)
			? '' + (hours - 12)
			: '12';
	}

	private minutesToString(minutes: number): string {
		return (minutes < 10)
			? '0' + minutes
			: '' + minutes;
	}

	private getMeridiem(hours: number) {
		return hours < 12 ? 'AM' : 'PM';
	}

	public interperetDateTimeAsLocal(dateTime: string): string {
        // Strip timezone. We're assuming the utcOffset will always be interpreted as +00:00 from Workforce DB.
        dateTime = dateTime.substring(0, dateTime.length - 6);
        // 'YYYY/MM/DD HH:mm:SS' format needed to work on iOS without timezone
        return moment(dateTime).format('YYYY/MM/DD HH:mm:SS');
    }
}
